<script>
  import { getContext } from "svelte";
  import Tick from "./Tick.svelte";
  const { scales } = getContext("BarChart");
  $: ticks = $scales.x.ticks(5).slice(1); // don't need to show 0
</script>

{#each ticks as value (value)}
  <Tick x="{$scales.x(value)}" value="{value}" />
{/each}